module.exports = ".headerHelperPayment {\n  width: 25%;\n  background: #0071bc;\n}\n.headerHelperPayment:hover {\n  background: #3c444f;\n}\n.approve-message {\n  margin-bottom: 30px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/meshutaf/event-meshutaf.component.css
// module id = ./src/app/admin/meshutaf/event-meshutaf.component.css
// module chunks = main